import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/small/',
  headTitle: 'Free Small Text Generator',
  headDescription:
    'Picsart provides a completely free and beginner-friendly small text generator to create postscripts, captions, footnotes, and more with ease.',
  heading: 'Small Text Generator for Any Purpose',
  description:
    'An assortment of small text fonts perfect for captions, postscripts, footnotes, and more.',
  selectedCategory: FontCategory.Small,
  inputPlaceholder: 'Make here your text small…',
  landingText: {
    imageSection: [
      {
        imgSrc: 'https://cdn140.picsart.com/16508150318983173891.webp',
        imgAlt: 'small text generator',
        imageWidth: 355,
        imageRight: false,
        title: 'What is a small text generator?',
        children: {
          paragraph: `There are a variety of situations where small text size is practical and often the standard. Postscripts to notes, footnotes, references, and captions all often require
            <a
              className="link--underline"
              href="https://picsart.com/fonts/?style=Small/"
              target="_blank"
              rel="noreferrer"
            >
              small font styles
            </a>
           and small text font, both for layout purposes and to fit stylistic guidelines such as APA, MLA, and other academic requirements. This is where a small text generator can make life easy for you. With the Picsart small text generator, simply copy and paste the text you want to convert to a small text font into the tool. Choose from a variety of stylish and fun fonts, and easily convert your text with the small font generator in moments.`,
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/64252641933304484096.webp',
        imgAlt: 'small font generator',
        imageWidth: 355,
        imageRight: true,
        title: 'How do you use the small font generator?',
        children: {
          paragraph:
            'For whatever reason you need a small text font, using the small text generator requires no learning curve, payment, or registration. Simply open the small font generator tool in your browser and copy the text you want to convert into the tool. Then, select from the array of small text fonts to find the perfect one for your specific purpose. Once you find the perfect option, simply copy the converted font out of the small text generator and into your web page or document and you are good to go!',
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/06350059335479530960.webp',
        imgAlt: 'small letter generator',
        imageWidth: 253,
        imageRight: false,
        title: 'Why use the Picsart small text generator?',
        children: {
          paragraph:
            'Picsart offers a small font generator with everything you need to convert your text with ease:',
          list: [
            'Simple copy-and-paste interface to quickly convert your font.',
            'A variety of font options to find the perfect font for any academic or personal purpose.',
            'The small text generator is completely free to use, and requires no sign-up.',
            'Convert your text with the small letter generator in seconds.',
            'Use it again and again to speed up your academic, professional, or personal copy creation and meet your formatting requirements.',
          ],
        },
      },
    ],
    howToSection: {
      title: 'How to use the small text generator',
      steps: [
        {
          title: 'Copy & paste your text',
          description:
            'Start by copying in the text that you wish to convert into the small text generator.',
        },
        {
          title: 'Choose your font',
          description:
            'Browse a variety of small text fonts to find the perfect font for your specific need.',
        },
        {
          title: 'Copy your converted text',
          description:
            'Once you found the right font, simply copy your converted text out of the small font generator into your web page or document and you are good to go.',
        },
      ],
      cta: 'Get Started!',
    },
    similarTools: {
      paragraph:
        'Looking for other useful text tools after using the small font generator? Picsart offers all the free and easy text tools you need!',
    },
    moreInfo: {
      title: 'Need some more info?',
      description: 'Picsarts friendly support team will be happy to help.',
      btn: 'Get in touch',
    },
  },
};

export default props;
